import * as React from "react";
const SvgSortGiftsArrows = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", viewBox: "11 12 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M29 27.128h3l-4 4-4-4h3v-14h2m-17 14h10v2H12m4-14v2h-4v-2m0 6h7v2h-7z" }));
export default SvgSortGiftsArrows;
